// Flights Widget Lazy loading

import $ from 'jquery';
import { initDatepickers } from './datepicker';

(function () {
  const widget = document.querySelector('.js-flight-schedule-widget')
  let isActive = false
  if (!widget)
    return

  const widgetMode = widget.dataset.mode

  async function initFlightWidget(mode) {
    if (widgetMode !== mode)
      return

    if (isActive) return;

    isActive = true
    const {default: createFlightWidget} = await import('flight-schedule-widget');

    createFlightWidget(widget);
    initDatepickers();
  }

  if (widgetMode === 'complete') {
    document.addEventListener('DOMContentLoaded', () => {
      initFlightWidget('complete')
    })
  } else {
    $('[data-tabs]').on('change.zf.tabs', async function () {
      initFlightWidget('simple')
    });

    $('.js-flights-widget-hover').on("mouseenter", function () {
      initFlightWidget('simple')
    })
  }

})();
